export default [
  {
    path: '/activity-20260313-highlight-rank',
    component: () => import('./Page.vue'),
    meta: { title: '高光时刻榜单', id: 24 },
  },
]
